import { IProductData } from "@/interfaces";
import { ProductDetailBox } from "./ProductDetailBox";
import { CategoryProductsSection } from "../categoryPage/CategoryProductsSection";

type props = {
    productData: IProductData
}
export function ProductPage({ productData }: props) {
    return (
        <>
            <ProductDetailBox data={productData} />
            <CategoryProductsSection products={productData.similarProducts} catSlug={productData.categorySlug} backgroundColor="#fff"/>
        </>
    )
}